import React, {Component} from 'react';
import {connect} from 'react-redux';
import { push } from 'connected-react-router'
import {logout} from "../../actions/user";
import {changeGeneralStoreSettings, closeAragUserSettingsMenu, openAragUserSettingsMenu} from "../../actions/general";
import AdminHeader from "../../components/Layout/AdminHeader";

class AdminHeaderHOC extends Component {

    _handleSettingsMenuClick = () => {
        this.props.changeStoreSettings({
            key: 'isSettingsMenuOpen',
            value: !this.props.isSettingsMenuOpen
        });
    };

	render(){
        return(
            <AdminHeader
                logout={this.props.logout}
                push={this.props.push}
                username={this.props.username}
                userRoles={this.props.userRoles}
                locationPathName={this.props.locationPathName}
                notificationsIconCount={this.props.notificationsIconCount}
                allowedToEditPremiumSettings={this.props.allowedToEditPremiumSettings}
                allowedToEditReferralSettings={this.props.allowedToEditReferralSettings}
                allowedToEditTobas={this.props.allowedToEditTobas}
                allowedToEditArticles={this.props.allowedToEditArticles}
                _handleSettingsMenuClick={this._handleSettingsMenuClick}
                isSettingsMenuOpen={this.props.isSettingsMenuOpen}
                openAragUserSettingsMenu={this.props.openAragUserSettingsMenu}
                closeAragUserSettingsMenu={this.props.closeAragUserSettingsMenu}
            />
        );
	}
};


const mapStateToProps = (state) => {
	return {
        isSettingsMenuOpen: state.general.isSettingsMenuOpen,
        locationPathName: state.router.location.pathname,
        username: state.user.loggedInUser.username,
        userRoles: state.user.loggedInUser.roles,
        notificationsIconCount: state.notifications.notificationsIconCount,
        //arag user page restrictions
        allowedToEditOtherApplications: state.user.loggedInUser.allowedToEditOtherApplications?state.user.loggedInUser.allowedToEditOtherApplications:false,
        allowedToEditPremiumSettings: state.user.loggedInUser.allowedToEditPremiumSettings?state.user.loggedInUser.allowedToEditPremiumSettings:false,
        allowedToEditReferralSettings: state.user.loggedInUser.allowedToEditReferralSettings?state.user.loggedInUser.allowedToEditReferralSettings:false,
        allowedToEditTobas: state.user.loggedInUser.allowedToEditTobas?state.user.loggedInUser.allowedToEditTobas:false,
        allowedToEditArticles: state.user.loggedInUser.allowedToEditArticles?state.user.loggedInUser.allowedToEditArticles:false
	}
};

const mapDispatchToProps = (dispatch) => {
    return {
        push: (url) => {
            dispatch(push(url))
        },
        logout: () => {
            dispatch(logout())
        },
        changeStoreSettings: (payload) => {
            dispatch(changeGeneralStoreSettings(payload))
        },
        openAragUserSettingsMenu: (payload) => {
            dispatch(openAragUserSettingsMenu(payload))
        },
        closeAragUserSettingsMenu: (payload) => {
            dispatch(closeAragUserSettingsMenu(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminHeaderHOC);